<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-card class="bCardQueja" v-if="vistaFiltrado == false">
      <!--    <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span class="fa fa-table"></span>
            <span>Quejas</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>C-**</div>
          </b-col>
        </b-row> -->

      <div class="divSubtitulo">
        <p class="textSubtitulo">Revisión de solicitud</p>
      </div>

      <div style="margin-top:2%; text-align: left;">

        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="nombre"
              >Nombre del paciente
                <validacion/>
              </label>
              <p>
                <label>{{ solicitud.paciente }}</label>
              </p>
            </b-form-group>
            <b-modal
                size="lg"
                v-if="solicitud.idPaciente != null"
                v-model="modalContacto"
                id="modDetalleCita"
                title="Contacto del paciente"
                scrollable
            >
              <div style="margin: 3%">
                <p>
                  Por favor seleccione un medio de contacto para el paciente
                </p>
                <div v-if="solicitud.idPaciente != null">
                  <ContactoPaciente
                      :idPaciente="solicitud.idPaciente"
                      @_setearValor="setearValor"
                  />
                </div>
              </div>
            </b-modal>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="clinica">Clínica</label>
              <v-select
                  id="clinica"
                  name="clinica"
                  disabled=""
                  placeholder="Clinica"
                  label="strNombre"
                  :options="clinicas"
                  :reduce="(i) => i.idClinica"
                  v-model="$v.solicitud.idClinica.$model"
                  :state="validateState('idClinica')"
                  :class="selectClass('idClinica')"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="origen"
              >Origen de incidencia
                <validacion/>
              </label>
              <v-select
                  id="origen"
                  name="origen"
                  placeholder="Origen de incidencia"
                  label="descripcion"
                  disabled
                  :options="origenes"
                  :reduce="(i) => i.id"
                  v-model="$v.solicitud.idOrigen.$model"
                  :state="validateState('idOrigen')"
                  :class="selectClass('idOrigen')"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="clasificacion"
              >Tipo de solicitud
                <validacion/>
              </label>

              <v-select

                  id="clasificacion"
                  name="clasificacion"
                  placeholder="Tipo de solicitud"
                  label="descripcion"
                  :options="tipoQuejas"
                  :reduce="(i) => i.id"
                  v-model="$v.solicitud.tipoQueja.$model"
                  :state="validateState('tipoQueja')"
                  :class="selectClass('tipoQueja')"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col  v-if="solicitud.tipoQueja !== null && solicitud.tipoQueja !== 2">
            <b-form-group align="left">
              <label for="especialidad"
              >Especialidad
                <validacion/>
              </label>
              <v-select
                  id="especialidad"
                  name="especialidad"
                  placeholder="Especialidad"
                  label="text"
                  :options="especialidades"
                  :reduce="(i) => i.value"
                  v-model="$v.solicitud.especialidad.$model"
                  :state="validateState('especialidad')"
                  :class="selectClass('especialidad')"
              ></v-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group align="left">
              <label for="clasificacion"
              >Motivo de solicitud
                <validacion/>
              </label>
              <v-select
                  id="clasificacion"
                  name="clasificacion"
                  placeholder="Motivo de solicitud"
                  label="description"
                  :options="clasificaciones"
                  :reduce="(i) => i.idClasificacion"
                  v-model="$v.solicitud.idClasificacion.$model"
                  :state="validateState('idClasificacion')"
                  :class="selectClass('idClasificacion')"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
            v-if="solicitud.idOrigen === 4"
        >
          <b-col>
            <b-form-group align="left">
              <label for="Calificacion"
              >Calificación
                <validacion/>
              </label>
              <v-select
                  id="Calificacion"
                  name="Calificacion"
                  placeholder="Calificación"
                  :options="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  v-model="$v.solicitud.calificacion.$model"
                  :state="validateState('calificacion')"
                  :class="selectClass('calificacion')"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="solicitud.idClasificacion === 4" >
          <b-col>
            <b-form-group align="left">
              <label for="clasificacion">Driver
                <validacion/>
              </label>
              <v-select id="clasificacion" name="clasificacion" placeholder="Driver"
                        label="descripcion"
                        :options="drivers"
                        :reduce="(i) => i.idDriver"
                        @input="obtenerTemas(true)"
                        v-model="$v.solicitud.driver.$model"
                        :state="validateState('driver')"
                        :class="selectClass('driver')"

              ></v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="especialidad">Tema
                <validacion/>
              </label>
              <v-select id="especialidad" name="especialidad" placeholder="Tema"
                        label="descripcion"
                        :disabled="solicitud.driver === null "
                        :options="temas"
                        :reduce="(i) => i.idTemaQueja"
                        @input="obtenerSubTemas(true)"
                        v-model="$v.solicitud.tema.$model"
                        :state="validateState('tema')"
                        :class="selectClass('tema')"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="clasificacion">Subtema
                <validacion/>
              </label>
              <v-select id="clasificacion" name="clasificacion" placeholder="Subtema"
                        label="descripcion"
                        :disabled="solicitud.tema === null"
                        :options="subtemas"
                        :reduce="(i) => i.idSubtemaQueja"
                        v-model="$v.solicitud.subtema.$model"
                        :state="validateState('subtema')"
                        :class="selectClass('subtema')"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="url">Descripción de la incidencia.</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="card-text"></b-icon>
                </b-input-group-prepend>
                <b-form-textarea
                    id="url"
                    name="url"
                    disabled
                    placeholder="Incidencia  "
                    type="text"
                    v-model="$v.solicitud.descripcion.$model"
                    :state="validateState('descripcion')"
                ></b-form-textarea>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-button
                v-if="solicitud.idPaciente != null"
                variant="outline-primary"
                :disabled="loaderGuardar"
                @click="abrirModalContacto()"
            >
              <span v-if="!loaderGuardar">Contacto</span>
              <span v-if="loaderGuardar">
                    <b-spinner small></b-spinner>
                    Cargando...
                  </span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-button
                variant="outline-primary"
                :disabled="loaderGuardar"
                @click="guardar()"
            >
              <span v-if="!loaderGuardar">Guardar</span>
              <span v-if="loaderGuardar">
                  <b-spinner small></b-spinner>
                  Cargando...
                </span>
            </b-button>
          </b-col>

        </b-row>

      </div>

    </b-card>
    <div v-if="vistaFiltrado ==true">
      <historial-quejas-paciente/>

    </div>
  </div>
</template>

<script>
import ContactoPaciente from "../../../components/paciente/ContactoPaciente";
import {TickeService} from "../../../apiServices/garantias/tickeService";
import {CatalogosService} from "../../../apiServices/catalogos/CatalogosService";
import {GarantiaService} from "../../../apiServices/garantias/GarantiaService";
import {required} from "vuelidate/lib/validators";
import Header from "../../../components/Header";

export default {
  name: "RevisionSolicitudQueja",
  components: {Header, ContactoPaciente},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      ticketServicio: new TickeService(),
      clinicas: [],
      origenes: [],
      tipoQuejas: [],
      clasificaciones: [],
      drivers: [],
      temas: [],
      subtemas: [],
      especialidades: [
        {value: 1, text: "Endodoncia"},
        {value: 2, text: "Periodoncia/Cirugía"},
        {value: 3, text: "Prótesis/OG"},
      ],

      paciente: null,
      listaBusquedaPaciente: [],

      loaderGuardar: false,

      solicitud: {
        idPaciente: null,
        idClinica: null,
        idOrigen: null,
        calificacion: null,
        especialidad: null,
        idClasificacion: null,
        descripcion: null,
        driver: null,
        tema: null,
        subtema: null,
        tipoQueja: null,
      },
      contactoSeleccionado: null,
      idTicket: null,
      idEtapa: null,
      modalContacto: false
    }
  },
  validations() {
    let datos;
    datos = {
      solicitud: {
        idPaciente: {required},
        idClinica: {required},
        idOrigen: {required},
        tipoQueja: {required},
        calificacion: {},
        especialidad: {},
        idClasificacion: {required},
        descripcion: {required},
        driver: {},
        tema: {},
        subtema: {},
      }
    }

    if (this.solicitud.tipoQueja !== null && this.solicitud.tipoQueja !== 2) {
      datos.solicitud.especialidad = {required}
    }

    if (this.solicitud.idClasificacion === 4) {
      datos.solicitud.driver = {required}
      datos.solicitud.tema = {required}
      datos.solicitud.subtema = {required}
    }

    if (this.solicitud.idOrigen === 4) {
      datos.solicitud.calificacion = {required}
    }

    return datos;
  },
  props: {
    idPaciente: Number,
    nombreCompleto: String,
    vistaFiltrado: Boolean,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerSolicitud();
    this.obtenerMotivos();
    this.obtenerDrivers();
    this.obtenerOrigenes();
    this.obtenerClasificaciones();
    this.obtenerClinicas();
    this.asignarIDPaciente();
  },
  methods: {
    asignarIDPaciente() {
      this.solicitud.idPaciente = this.idPaciente;
    },
    abrirModalContacto() {
      this.modalContacto = true;
    },
    setearValor(valor) {
      this.contactoSeleccionado = valor;
    },
    obtenerOrigenes() {
      this.garantiaServicio.obtenerOrigenQuejas().then(response => {
        this.origenes = response.data;
      })
    },
    obtenerClinicas() {
      this.catalogoServicio.listaClinicas().then(response => {
        this.clinicas = response;
      })
    },
    obtenerClasificaciones() {
      let body ={
        "idClasificacion": 4
      }
      this.catalogoServicio.obtenerClasificaciones(body).then(response => {
        this.clasificaciones = response.data;
      })
    },
    seleccinarPaciente(paciente) {
      this.solicitud.idPaciente = paciente.idPaciente;
      //buscamos los planes del paciente
    },
    getBuscarPacienteServicio(search, loading) {
      loading(true);
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        const params = {
          nombrePaciente: search
        }
        this.$http
            .post(
                this.$api +
                "paciente/perfiles/obtenerpacientes/activos", params)
            .then((response) => {
              if (response.data.data) {
                this.listaBusquedaPaciente = [];
                let resultado = response.data.data;
                resultado.forEach((item, index) => {
                  item.id = index;
                  this.listaBusquedaPaciente.push(item);
                });
                loading(false);
              }
            })
            .catch(function (error) {
              console.error(error);
              loading(false);
              this.$swal({
                icon: "error",
                text: "A ocurrido un error, intentalo más tarde.",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            });
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },
    guardar() {

      this.$v.solicitud.$touch();
      if (this.$v.solicitud.$anyError) {
        return false;
      }
      this.loaderGuardar = true
      const envio = JSON.parse(JSON.stringify(this.solicitud))
      envio.dato = 2
      envio.idSolicitud = this.idTicket
      envio.idEtapa = this.idEtapa
      this.garantiaServicio.guardarSolicitud(envio)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false
            });
            this.vistaFiltrado = true;
            this.$v.$reset()
             window.history.back();
          })
          .finally(() => {
            this.loaderGuardar = false;
          })
    },
    obtenerMotivos() {
      this.garantiaServicio.obtenerMotivos()
          .then(response => {
            this.tipoQuejas = response.data
          })
    },
    obtenerDrivers() {
      this.garantiaServicio.obtenerDrivers()
          .then(response => {
            this.drivers = response.data
          })
    },
    obtenerSolicitud() {

      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerSolicitud(parametros)
          .then(response => {
            this.solicitud = response.data
            if (this.solicitud.subtema != null){
              this.obtenerTemas(false)
              this.obtenerSubTemas(false)
            }
          })
    },
    obtenerTemas(reinicar) {
      if (reinicar){
        this.solicitud.tema= null
        this.solicitud.subtema = null
      }

      const parametros = {idDriverQueja: this.solicitud.driver}
      this.garantiaServicio.obtenerTema(parametros)
          .then(response => {
            this.temas = response.data
          })
    },
    obtenerSubTemas(reinicar) {
      if (reinicar){
        this.solicitud.subtema = null
      }
      let body ={
        "idTemaQueja": this.solicitud.tema
      }
      this.garantiaServicio.obtenerSubTema(body)
          .then(response => {
            this.subtemas = response.data
          })
    },


    validateState(name) {
      const {$dirty, $error} = this.$v.solicitud[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }

  }
}
</script>

<style scoped>
.bCardQueja {
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  border-bottom: 5px solid #8EC6E9;
}

.divInput {
  width: 100%;
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}
</style>
